import Styles from 'src/components/Styles';
import {
  StyleSheet,
  View,
  Text,
  Platform,
  TouchableOpacity,
  PixelRatio,
} from 'react-native';
import {
  CustomTilesButtonStylesDescriptor,
  ProductModifierRadioButton,
  CheckoutBarProps,
  PickupLocationListStylesDescriptor,
  RecentOrdersButtonStylesDescriptor,
  ProductModifierStylesDescriptor,
} from 'src/components/elements/orderAhead/descriptor/DescriptorType';
import RadioForm, {RadioButton} from 'react-native-simple-radio-button';
import CustomRadiobutton from '../../CustomRadioButton';
import {checkValue} from 'src/Util';
import Localized from 'src/constants/AppStrings';
import {CheckBox} from 'react-native-elements';
import {ProductModifierValue} from 'src/types/Menu';
import FontAwesome5Pro from '../../../icons/FontAwesomeIcon';
import ItemAddedFeedback from '../../cart/ItemAddedFeedback';
import MenuService from 'src/services/MenuService';
import TimeUtils from 'src/services/TimeUtils';

export function customTilesButtonStyles(): CustomTilesButtonStylesDescriptor {
  return StyleSheet.create({
    text: {
      fontSize: Styles.Fonts.f7,
      paddingHorizontal: Styles.Spacing.m2,
      color: Styles.Colors.CompanyKitchen.black,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.latoRegular,
    },
    tileConatainer: {
      alignItems: 'center',
      flexDirection: 'row',
      height: Styles.Heights.h6,
      minWidth: 135,
      paddingHorizontal: Styles.Spacing.m2 + 4,
      justifyContent: 'flex-start',
      borderColor: Styles.lightGray,
      borderWidth: 1,
      paddingVertical: Styles.Spacing.m3,
      borderRadius: Styles.Spacing.m2,
      overflow: 'hidden',
    },
    selectedText: {
      fontWeight: '700',
      color: Styles.Colors.CompanyKitchen.black,
    },
    selectedView: {
      borderColor: Styles.lightGray,
      backgroundColor: Styles.Colors.CompanyKitchen.blue,
      borderWidth: 1,
    },
  });
}

export function pickupLocationListStyles(): PickupLocationListStylesDescriptor {
  return StyleSheet.create({
    cell: {
      alignItems: 'center',
      marginTop: Styles.Spacing.m3,
      borderRadius: Styles.Spacing.m2,
      padding: Styles.Spacing.m3,
      borderColor: Styles.Colors.CompanyKitchen.lightGray,
      borderWidth: 1,
      flexDirection: 'row',
      minHeight: Styles.Heights.touchTargetHeight2,
      overflow: 'hidden',
    },
    label: {
      color: Styles.Colors.CompanyKitchen.black,
      fontWeight: '400',
      fontSize: Styles.Fonts.f7,
      paddingLeft: Styles.Spacing.m2,
      paddingRight: Styles.Spacing.m4,
      fontFamily: Styles.FontFamily.latoRegular,
      overflow: 'hidden',
    },
    cellSelected: {
      padding: Styles.Spacing.m3,
      borderWidth: 2.5,
      flexDirection: 'row',
      borderColor: Styles.Colors.CompanyKitchen.blue,
      marginTop: Styles.Spacing.m3,
      alignItems: 'center',
      borderRadius: Styles.Spacing.m2,
      backgroundColor: Styles.white,
    },
    selectedLabel: {
      color: Styles.Colors.CompanyKitchen.black,
      paddingLeft: Styles.Spacing.m2,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.latoRegular,
      fontSize: Styles.Fonts.f7,
    },
  });
}

export function pickupLocationInnerCircleBackgroundColor(): string {
  return Styles.Colors.CompanyKitchen.blue;
}

export function pickupLocationOuterCircleBorderColor(): string {
  return Styles.Colors.CompanyKitchen.blue;
}

export function productModifierStyles(): ProductModifierStylesDescriptor {
  return StyleSheet.create({
    radioButtonWrapper: {
      backgroundColor: Styles.white,
      padding: Styles.Spacing.m1,
      justifyContent: 'center',
      marginLeft: Styles.Spacing.m0,
    },
    customizationDivider: {
      borderWidth: 0,
      borderBottomWidth: 1,
      borderColor: Styles.lightGray,
      marginTop: Styles.Spacing.m1,
      borderRadius: null,
    },
    checkboxCalorieContainer: {
      alignItems: 'flex-end',
      flexDirection: 'column',
      flex: 3,
      color: Styles.darkColor,
      marginRight: Styles.Spacing.m2,
    },
    checkboxNameContainer: {
      flex: 7,
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginRight: Styles.Spacing.m2,
    },
    checkboxRow: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    checkboxPriceContainer: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      flex: 3,
    },
    titleText: {
      fontWeight: '600',
      color: Styles.darkColor,
      flex: 0.8,
      fontSize: Styles.Fonts.f1,
    },
    requiredViewStyles: {
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'space-between',
    },
    options: {
      paddingVertical: Styles.Spacing.m2,
    },
    requiredText: {
      color: Styles.dangerColor,
      fontSize: Styles.Fonts.f1,
      fontStyle: 'italic',
    },
    totalCaloriesLabel: {
      fontWeight: '400',
      fontSize: Styles.Fonts.f1,
    },
    sectionCalStyles: {
      fontWeight: Styles.bold,
      fontSize: 16,
      marginRight: Styles.Spacing.m2,
      color: Styles.darkColor,
    },
    checkBoxWrapper: {
      justifyContent: 'center',
      padding: Styles.Spacing.m1,
      minHeight: Styles.Heights.h3,
      backgroundColor: Styles.white,
      marginLeft: Styles.Spacing.m0,
      margin: null,
    },
    productModifierContainer: {
      backgroundColor: Styles.bgColor,
    },
    checkBoxText: {
      color: Styles.darkColor,
      marginLeft: Styles.Spacing.m2,
    },
    optionText: {
      fontSize: Styles.Fonts.f0,
      marginTop: -Styles.Spacing.m1 / 2,
      marginLeft: Styles.Spacing.m2,
      color: Styles.darkColor,
      marginBottom: 5,
    },
    titleRow: {
      justifyContent: 'space-between',
      marginTop: Styles.Spacing.m3,
      flexDirection: 'row',
    },
    helperText: {
      alignSelf: 'flex-start',
    },
  });
}
export function radioButtonProductModifier(
  buttons: ProductModifierRadioButton[],
  values: string[],
  showCalories: boolean,
  showUnitName: string,
  onPress,
): JSX.Element {
  return (
    <RadioForm>
      {buttons.map((obj, i) => {
        const isSelected = values.includes(obj.value);
        return (
          <View
            accessibilityRole="radio"
            accessibilityState={{
              selected: isSelected,
            }}
            key={obj.value + '-' + i}
            style={productModifierStyles().customizationDivider}
            accessible={true}
          >
            <RadioButton
              style={productModifierStyles().radioButtonWrapper}
              key={i}
            >
              <CustomRadiobutton
                accessibilityLabel={obj.label}
                aria-label={obj.label}
                onPress={() => onPress(obj.value)}
                selected={isSelected}
                outerCircleStyle={{
                  borderColor: Styles.Colors.CompanyKitchen.black,
                }}
                innerCircleStyle={{
                  backgroundColor: Styles.Colors.CompanyKitchen.blue,
                }}
              />
              <View style={productModifierStyles().checkboxRow}>
                <View style={productModifierStyles().checkboxNameContainer}>
                  <Text
                    accessibilityLabel={`${obj.label}, `}
                    style={{
                      color: Styles.darkColor,
                      width: Platform.OS === 'web' ? '100%' : undefined,
                      marginLeft: Styles.Spacing.m1,
                    }}
                    aria-label={`${obj.label}, `}
                    maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
                  >
                    {obj.label}
                  </Text>
                </View>
                <View style={productModifierStyles().checkboxPriceContainer}>
                  {obj.price !== null && (
                    <Text
                      aria-label={`${obj.price}, `}
                      accessibilityLabel={`${obj.price}, `}
                      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
                      style={{color: Styles.darkColor}}
                    >
                      {obj.price}
                    </Text>
                  )}
                </View>

                <View style={productModifierStyles().checkboxCalorieContainer}>
                  {showCalories && checkValue(obj.calories) && (
                    <Text
                      aria-label={`${
                        obj.calories
                      } ${Localized.Labels.calories.toLowerCase()}`}
                      accessibilityLabel={`${
                        obj.calories
                      } ${Localized.Labels.calories.toLowerCase()}`}
                      style={{color: Styles.darkColor}}
                      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
                    >
                      {`${obj.calories} ${showUnitName}`}
                    </Text>
                  )}
                </View>
              </View>
            </RadioButton>
          </View>
        );
      })}
    </RadioForm>
  );
}

export function checkboxProductModifiers(
  value: ProductModifierValue,
  price: string,
  calories: string,
  modifierValues: string[],
  showUnitName: string,
  showCalories: boolean,
  onPress,
): JSX.Element {
  return (
    <CheckBox
      key={value.id}
      accessible={true}
      aria-label={`${value.name}, ${price}, ${calories}`}
      accessibilityRole="checkbox"
      accessibilityLabel={`${value.name}, ${price}, ${calories}`}
      aria-checked={modifierValues.includes(value.id)}
      role="checkbox"
      accessibilityState={{
        checked: modifierValues.includes(value.id),
      }}
      title={
        <View style={productModifierStyles().checkboxRow}>
          <View style={productModifierStyles().checkboxNameContainer}>
            <Text
              style={{
                marginLeft: Styles.Spacing.m1,
                color: Styles.darkColor,
              }}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
            >
              {value.name}
            </Text>
          </View>
          {price !== null && (
            <View style={productModifierStyles().checkboxPriceContainer}>
              <Text
                style={{color: Styles.darkColor}}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
              >
                {price}
              </Text>
            </View>
          )}
          {showCalories && checkValue(value.calories) && (
            <View style={productModifierStyles().checkboxCalorieContainer}>
              <Text
                style={{color: Styles.darkColor}}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
              >
                {`${value?.calories} ${showUnitName}`}
              </Text>
            </View>
          )}
        </View>
      }
      size={Styles.Fonts.f2}
      checked={modifierValues.includes(value.id)}
      textStyle={[
        productModifierStyles().optionText,
        productModifierStyles().checkBoxText,
      ]}
      containerStyle={productModifierStyles().checkBoxWrapper}
      checkedColor={Styles.Colors.CompanyKitchen.black}
      onPress={() => onPress(value.id)}
      uncheckedColor={Styles.Colors.CompanyKitchen.black}
    />
  );
}
export function getCounterText(value, FREE_TEXT_MAX_LENGTH): string {
  return `${FREE_TEXT_MAX_LENGTH - (value?.length || 0)} ${
    Localized.Labels.characters_left
  }`;
}

export function recentOrderButtonStyle(): RecentOrdersButtonStylesDescriptor {
  return StyleSheet.create({
    marginStyle: {
      marginBottom:
        Platform.OS === 'android' ? Styles.Heights.h1 : Styles.Spacing.m2 + 1,
      marginTop: 0,
    },
    recentOrderText: {
      color: Styles.black,
      fontSize: Styles.Fonts.f2,
      marginLeft: Styles.Spacing.m2,
      lineHeight: Styles.Fonts.f3,
    },
  });
}

export function checkoutBarUI({
  numItems,
  pickupTime,
  displayLocation,
  onPress,
}: CheckoutBarProps) {
  let formattedLabel = '';
  let topRow = (
    <Text
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
      style={styles.title}
    >
      {Localized.Labels.pickup_at}
    </Text>
  );

  if (pickupTime) {
    const timeLabel = TimeUtils.isDateGreaterThanToday(pickupTime.date)
      ? Localized.Labels.pickup_tomorrow
      : Localized.Labels.pickup_today;

    formattedLabel =
      Localized.Labels.formatString(timeLabel, pickupTime.time) +
      ` ${MenuService.getTimezoneDisplay()}`;

    topRow = (
      <View style={{flexDirection: 'column'}}>
        <View style={styles.row}>
          <Text
            style={styles.title}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            adjustsFontSizeToFit
            numberOfLines={1}
          >
            {formattedLabel}
          </Text>
        </View>
      </View>
    );
  }

  // Set text for cart item
  const cartItemText = numItems > 1 ? 'items' : 'item';
  const cart = (
    <View style={styles.cart}>
      {numItems > 0 && (
        <Text
          style={styles.cartText}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
        >
          View
        </Text>
      )}
      <View>
        <FontAwesome5Pro
          name="shopping-cart"
          size={Styles.Fonts.f4}
          color={Styles.Colors.CompanyKitchen.black}
          solid
        />
        <View style={styles.badge}>
          {numItems > 0 && (
            <Text
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
              style={styles.badgeText}
            >
              {numItems}
            </Text>
          )}
        </View>
      </View>
      {numItems === 0 && <View style={styles.dummy} />}
    </View>
  );

  return (
    <TouchableOpacity
      accessible={true}
      accessibilityLabel={`${formattedLabel}, ${displayLocation}, View ${numItems} ${cartItemText} in cart`}
      aria-label={`${formattedLabel}, ${displayLocation}, View ${numItems} ${cartItemText} in cart`}
      accessibilityHint="Double tap to view your cart"
      accessibilityRole="button"
      role="button"
      accessibilityState={{
        disabled: numItems === 0 || !onPress,
      }}
      onPress={onPress}
      disabled={numItems === 0 || !onPress}
      style={styles.container}
    >
      <View style={styles.wrapper}>
        <View style={styles.content}>
          {topRow}
          <View style={styles.row}>
            <Text
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
              style={styles.description}
            >
              {displayLocation}
            </Text>
          </View>
        </View>
        <View style={styles.itemAddedFeedbackView}>
          <ItemAddedFeedback
            strings={Localized}
            textColor={Styles.Colors.CompanyKitchen.black}
            viewColor={Styles.Colors.CompanyKitchen.blue}
            countTextColor={Styles.white}
          />
        </View>
      </View>
      {cart}
    </TouchableOpacity>
  );
}

export function requiredModifiersView(
  name: string,
  showCalories?: boolean,
  caloricSection?: JSX.Element,
): JSX.Element {
  return (
    <View style={productModifierStyles().requiredViewStyles}>
      <Text
        accessible={true}
        accessibilityLabel={`${name} section`}
        aria-label={`${name} section`}
        style={productModifierStyles().titleText}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
      >
        {name}
      </Text>
      <View>
        <Text
          accessibilityLabel="Selection is required"
          aria-label="Selection is required"
          accessible={true}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          style={styles.requiredText}
        >
          {Localized.Labels.required}
        </Text>

        <View style={styles.calorieSectionView}>
          {showCalories && caloricSection}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Styles.Colors.CompanyKitchen.green,
    flexDirection: 'row',
  },
  title: {
    color: Styles.Colors.CompanyKitchen.black,
    fontWeight: '600',
    fontSize: Styles.Fonts.f1,
  },
  content: {
    flexDirection: 'column',
    flex: 1,
    paddingVertical: Styles.Spacing.m2,
    paddingBottom: Styles.Spacing.m3,
    paddingHorizontal: Styles.Spacing.m3,
  },
  description: {
    fontSize: Styles.Fonts.f0,
    color: Styles.Colors.CompanyKitchen.black,
  },
  wrapper: {
    position: 'relative',
    flex: 3,
    flexDirection: 'column',
  },
  itemAddedFeedbackView: {
    position: 'absolute',
    flexDirection: 'row',
    top: Styles.Spacing.m0,
    right: Styles.Spacing.m0,
    left: Styles.Spacing.m0,
    bottom: Styles.Spacing.m0,
  },
  row: {
    flexDirection: 'row',
  },
  cartText: {
    fontSize: Styles.Fonts.f1 * 1.1,
    paddingRight: Styles.Spacing.m2,
    fontWeight: '600',
    color: Styles.Colors.CompanyKitchen.black,
  },
  cart: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    backgroundColor: Styles.Colors.CompanyKitchen.blue,
    alignSelf: 'stretch',
    flexDirection: 'row',
    color: Styles.Colors.CompanyKitchen.blue,
    paddingVertical: Styles.Spacing.m2 + PixelRatio.getFontScale() * 1.3,
    paddingHorizontal: Styles.Spacing.m3,
  },
  dummy: {
    backgroundColor: Styles.Colors.CompanyKitchen.green,
    paddingTop: Styles.Spacing.m1,
    bottom: Styles.Spacing.m0,
    left: Styles.Spacing.m0,
    zIndex: 1,
    paddingBottom: Styles.Spacing.m3,
    paddingLeft: Styles.Spacing.m1,
    position: 'absolute',
    right: Styles.Spacing.m0,
    top: Styles.Spacing.m0,
  },
  badge: {
    position: 'absolute',
    alignItems: 'center',
    top: Styles.Spacing.m1,
    justifyContent: 'center',
    left: Styles.Spacing.m0,
    right: Styles.Spacing.m0,
    bottom: Styles.Spacing.m0,
    zIndex: 1,
  },
  badgeText: {
    fontSize: Styles.Fonts.f0,
    fontWeight: 'bold',
    paddingLeft: Styles.Spacing.m1,
    color: Styles.white,
    paddingTop: Styles.Spacing.m1,
    paddingBottom: Styles.Spacing.m3,
  },
  calorieSectionView: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'flex-end',
  },
  requiredText: {
    fontStyle: 'italic',
    fontSize: Styles.Fonts.f1,
    color: Styles.dangerColor,
  },
});

export function getActiveIconColor() {
  return Styles.primaryColor;
}
export function getInActiveIconColor() {
  return Styles.darkColor;
}

export function getMenuListCompnentsFontFamily() {
  return Styles.FontFamily.latoRegular;
}

export default {
  customTilesButtonStyles,
  pickupLocationListStyles,
  recentOrderButtonStyle,
  productModifierStyles,
  radioButtonProductModifier,
  checkboxProductModifiers,
  getCounterText,
  checkoutBarUI,
  requiredModifiersView,
  pickupLocationInnerCircleBackgroundColor,
  pickupLocationOuterCircleBorderColor,
  getActiveIconColor,
  getInActiveIconColor,
  getMenuListCompnentsFontFamily,
};
